import { useRootStore } from '@/stores/root.store';

export default (to) => {
  const store = useRootStore();
  // if not production and not staging, allow
  if (!store.configuration.isProduction && !store.configuration.isStaging) {
    return true;
  }

  // if meta enabled, allow
  if (to.meta?.enabled) {
    return true;
  }

  // otherwise, return to default route
  return { name: 'account#new' };
};
